module.exports = __webpack_public_path__ + "static/slider2-9916e6c5e4a81f39ee13b432535ad0b2.jpg";